import { Injectable } from '@angular/core';
import { APP_CONST } from '../../app.const';
import { RequestService } from '../../libraries/http/request.service';

@Injectable()
export class LocationRestService {
  baseURL = `${APP_CONST.API_MASTER}/admin/locations`;
  request = this._request.new(this.baseURL);

  constructor(private _request: RequestService) {}

  create(payload: any) {
    return this.request.post<any>(``, payload);
  }

  findAll(queryParams: any = {}) {
    return this.request.get<any>(``, { params: queryParams });
  }

  load(locationId: string) {
    return this.request.get<any>(`${locationId}`);
  }

  delete(locationId: string) {
    return this.request.delete<any>(`${locationId}`);
  }

  update(locationId: string, payload: any) {
    return this.request.put<any>(`${locationId}`, payload);
  }
}
